
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import DropDown from '~/components/common/modals/payment/DropDown.vue'

@Component({
  components: {
    DropDown
  }
})
export default class ExpirationDate extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value!: { month: string; year: string; }
  @Prop({ type: Array, required: true }) months!: string[]
  @Prop({ type: Array, required: true }) years!: string[]

  data = {
    month: 'MM',
    year: 'YY'
  }

  @Watch('value', { immediate: true, deep: true })
  setExternalDateValue({ month, year }) {
    this.data.month = month
    this.data.year = year
  }

  setDate(dateType, value) {
    this.data[dateType] = value
    this.$emit('input', { month: this.data.month, year: this.data.year })
  }
}
